import { createStyles } from '@mantine/styles';


export default createStyles((
    theme: {
        colors: { [x: string]: any[] };
        other: any;
        colorScheme: any;
        fn: any;
        shadows: any;
    }) => ({

    progress: {
        textAlign: 'center',
    },

    favoritesLanding: {
        margin: '0 auto',
        maxWidth: theme.other.maxWidth,
        paddingLeft: 20,
        paddingRight: 20,
    },

    h1: {
        textAlign: 'center',
        letterSpacing: 0.6,
        width: '100%',
        color: theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.colors.gray[7],
    },

    h2: {
        textAlign: 'center',
        letterSpacing: 0.6,
        width: '100%',
        color: theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.colors.gray[7],
    },

    titleGroup: {
        gap: 0,
    },


    // no favourite message

    paper: {
        margin: '0 auto',
        textAlign: 'justify',
        fontSize: 12,
        maxWidth: 500,
        padding: 20,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.colorScheme === 'dark' ? theme.colors.gray[8] : theme.colors.gray[3],
        boxShadow: theme.shadows.sm,
        color: theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.colors.gray[7],
    },

    submitButton: {
        fontWeight: 500,
        textTransform: 'uppercase',
        letterSpacing: 1,
        width: '100%',
        // marginBottom: 20,
    },

}));
